<template>
    <div>
        <el-row class="searchSection">
            <el-form ref="form" :inline="true" :model="searcheModel" class="external-form">
                <el-form-item label="回款目标月">
                    <el-date-picker
                    size="small"
                    v-model="searcheModel.months"
                    type="monthrange"
                    format="yyyy-MM"
                    value-format="yyyy-MM"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="录单时间">
                    <el-date-picker
                        size="small"
                        v-model="searcheModel.created_at"
                        type="daterange"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                    >
                    </el-date-picker>
                </el-form-item>
                
                <el-form-item label="所属部门">
                    <UserCascader
                    v-model="searcheModel.branch_id"
                    ref="branch"
                    :isBusiness="true"
                    :branch_id="parseInt(searcheModel.branch_id)"
                    @change="changeBranch"
                    ></UserCascader>
                </el-form-item>
                <el-form-item label="业务员">
                    <UserSelect ref="user" :uid="parseInt(searcheModel.user_id)" @change="changeUser"></UserSelect>
                </el-form-item>
                <el-form-item label="实际回款时间">
                    <el-date-picker
                        size="small"
                        v-model="searcheModel.actual_at"
                        type="daterange"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                    >
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="计划回款时间">
                    <el-date-picker
                        size="small"
                        v-model="searcheModel.plan_at"
                        type="daterange"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                    >
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="回款周期">
                    <el-select size="small" v-model="searcheModel.cycle" placeholder="请选择">
                        <el-option label="不限" value=""></el-option>
                        <el-option label="1个月以内" value="1"></el-option>
                        <el-option label="1-2个月" value="2"></el-option>
                        <el-option label="2-3个月" value="3"></el-option>
                        <el-option label="3-6个月" value="4"></el-option>
                        <el-option label="6-12个月" value="5"></el-option>
                        <el-option label="1年以" value="6"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="small" @click="submitSearch">搜索</el-button>
                    <el-button @click="resetForm()" size="small">重置</el-button>
                    <ExportFile 
                    v-if="Acs('/payment-count/' + activeName)"
                    :url="'/api/export/' + activeName" 
                    :params="searcheModel" 
                    filename="回款明细汇总" 
                    buttonName="导出Excel">
                    </ExportFile>
                </el-form-item>
            </el-form>
        </el-row>

        <el-row class="searchSection">
            <el-col :span="22">
                <p style="color:#85CE61;">
                    说明：统计已回款的订单数据
                </p>
            </el-col>
            <el-col :span="2">
                <CountConfig v-if="Acs('/count-config/view')" :path="searcheModel.path" :tab="searcheModel.tab"></CountConfig>
            </el-col>
        </el-row>
        <div class="main-bd mg20 pro-visible" v-loading="loading">
            <el-table 
            v-if="!loading"
            :data="list" 
            border 
            height="600"
            row-key="id" 
            :header-cell-style="{background: '#f3faff'}"
            >
            <template v-for="(item, index) in fields">
                <el-table-column :prop="item.prop" :label="item.label" v-bind="{ width: item.width }" :key="index">
                    <template slot="header" v-if="item.content">
                        <span>{{item.label}}</span>
                        <el-tooltip class="item" effect="dark" :content="item.content" placement="top">
                            <i class="el-icon-info"></i>
                        </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                        <el-button type="text" @click="handleView(scope.row)" v-if="item.click">
                            {{ scope.row[item.field] instanceof Array ? scope.row[item.field].join(',') : scope.row[item.field] }}<span v-if="item.type && scope.row[item.field]">%</span>
                        </el-button>
                        <span v-else>
                            {{ scope.row[item.field] instanceof Array ? scope.row[item.field].join(',') : scope.row[item.field] }}<span v-if="item.type && scope.row[item.field]">%</span>
                        </span>
                    </template>
                </el-table-column>
            </template>
            </el-table>
            <MyPagination :linkPage="linkPage" @size-change="handleSizeChange" @current-change="handleCurrentChange"></MyPagination>
        </div>
    </div>
  </template>
  <style scoped>
  </style>
  <script>
  import PaymentCount from "~/services/PaymentCount";
  import UserCascader from "~/widgets/UserCascader.vue";
  import UserSelect from "~/widgets/UserSelect.vue";
  import Config from "~/config/params";
  import ExportFile from "~/widgets/ExportFile.vue";
  import CountConfig from "~/widgets/CountConfig.vue";
  import MyPagination from "~/widgets/MyPagination.vue";
  export default {
  
    components: {
        UserCascader,
        UserSelect,
        Config,
        ExportFile,
        CountConfig,
        MyPagination
    },
  
    props: {
        activeName: {
            type: String,
            default: ''
        }
    },
  
    data() {
        return {
            linkPage: null,

            loading: false,
            list: [],
            searcheModel: {},
            fields: [
                {field: 'order_id', label: '订单ID', click: true, width: 200},
                {field: 'created_at', label: '录单时间'},
                {field: 'district_names', label: '地区'},
                {field: 'customer_name', label: '客户名称'},
                {field: 'total_amount', label: '销售额'},
                {field: 'contract_start_time', label: '合同开始时间'},
                {field: 'goal_month', label: '回款目标月份'},
                {field: 'plan_at', label: '计划回款时间'},
                {field: 'plan_amount', label: '计划回款金额'},
                {field: 'actual_at', label: '实际回款时间'},
                {field: 'actual_amount', label: '实际回款金额'},
                {field: 'finish_amount', label: '回款完成额'},
                {field: 'not_finish_amount', label: '未回款金额'},
                {field: 'actual_cycle', label: '回款周期'},
                {field: 'actual_day_num', label: '回款账期'},
                {field: 'user_name', label: '业务员'},
                {field: 'customer_user_name', label: '客户负责人'},
                {field: 'branch_name', label: '部门'},
            ],
        };
    },
  
    mounted() {
        
    },
  
    created() {
        this.resetForm(this.$route.query);
    },
  
    methods: {
        //重置按钮
        resetForm(params = null) {
            this.list = [];
            if(params && Object.keys(params).length > 0){
                this.searcheModel = Object.assign({}, this.searcheModel, params);
            }else{
                this.searcheModel = {
                    months: Config.getDataTimes('this_month'),
                    created_at: [],
                    actual_at: [],
                    plan_at: [],
                    branch_id: "",
                    user_id: "",
                    path: '/count/saleanalysis',
                    tab: 'goal-manage-actual',
                    count_type: '1'
                };
            }
            if(this.$refs['user']){
                this.$refs['user'].reset();
            }
            if(this.$refs['branch']){
                this.$refs['branch'].reset();
            }
            this.list = [];
            this.submitSearch();
        },
    
        // 筛选查询
        submitSearch() {
            let params = _.clone(this.searcheModel);
            _.each(params, (val, key) => {
                // 如果值是假值，除了数字 0 和字符串 '0'，都删除该键
                if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
                    delete params[key];
                }
            })
            this.getList(params);
        },
    
        getList(params) {
            // loading 动画
            this.loading = true;
            PaymentCount.getList(params, 'payment-detail').then((res) => {
                if (res.code == 0) {
                    this.list = res.data;
                }
                if (res._meta) {
                    this.linkPage = res._meta;
                }
                this.loading = false;
            }).catch((err) => {
                console.error(err);
                this.loading = false;
            });
        },


        //切换业务员子组件
        changeUser(object) {
            this.searcheModel.user_id = object.label;
        },

        //切换部门子组件
        changeBranch(value) {
            if (value.length > 0) {
                // 取得最后一级部门作为所属部门
                this.searcheModel.branch_id = value[value.length - 1];
            } else {
                this.searcheModel.branch_id = "";
            }
        },

        // 查看
        handleView(row) {
            let routeData = this.$router.resolve({
                path: "/order/view",
                query: {id: row.order_id},
            });
            window.open(routeData.href, '_blank');
        },

        handleSizeChange(newSize) {
            // 处理每页条目数变化事件
            this.searcheModel['perPage'] = newSize;
            this.submitSearch();
        },

        handleCurrentChange(newPage) {
            // 处理当前页码变化事件
            this.searcheModel['page'] = newPage;
            this.submitSearch();
        },
    },
  };
  </script>


// WEBPACK FOOTER //
// src/views/count/table/paymentDetail.vue